export default __webpack_public_path__ + "static/filter-tag-customer-fed9c3c33799b6ea0a074785ca776542.mp4";